import React, {Component, PropTypes} from 'react';
import styles from './thickbox.pcss';

class Thickbox extends Component {
	static default_width = 630;
	static default_height = 535;

	constructor( props ){
		super( props );
		this.state = {
			open : true,
			title : props.title
		};
		this.close.bind( this );
	}

	change_title( $title ){
		this.setState({
			title : $title
		});
	}

	close(){

		this.setState({
			open : false
		})
	}

	render(){
		if( !this.state.open ){
			return null;
		}

		var window_styles = {
			width: this.props.width + 'px',
			height: this.props.height + 'px'
		};

		return (
			<div>
				<div className={styles.overlay}></div>
				<div className={styles.window} style={window_styles}>
					<div className={styles.title}>
						<div className={styles.window_title}>
							{this.state.title}
						</div>
						<div className={styles.close}>
							<a href="#" onClick={this.close.bind( this )}>
								<div className={styles.close_icon}></div>
							</a>
						</div>
					</div>
					<div className={styles.content}>
						{/* Add the close method as a prop to each child so we can close inner components */}
						{React.cloneElement( this.props.children, {close : this.close.bind( this ), change_title : this.change_title.bind( this )})}
					</div>
				</div>
			</div>
		);

	}
}

Thickbox.propTypes = {
	title    : PropTypes.string.isRequired,
	children : PropTypes.object.isRequired
};

Thickbox.defaultProps = {
	title    : "",
	children : {}
};

export default Thickbox;


// WEBPACK FOOTER //
// ./src/components/modals/thickbox.js